import { AssetWatchLogo, Chip, Label } from "@assetwatch/ui";
import { useTranslation } from "react-i18next";

export function MarketplaceBrandLabel() {
  const { t } = useTranslation();

  return (
    <div className="flex min-w-0 items-end gap-(--spacing-8) uppercase">
      <AssetWatchLogo aria-label="AssetWatch" />
      <Label size="xs" tone="subtle">
        {t("marketplace.title", { defaultValue: "Marketplace" })}
      </Label>
      <Chip
        data-testid="marketplace-beta-label"
        label={t("marketplace.betaBadge", { defaultValue: "Beta" })}
      />
    </div>
  );
}
